export const OPEN_CUSTOMER_SET = 'at/panels/customer/OPEN_CUSTOMER_SET'
export const CUSTOMER_PANEL_OPENED_FROM_URL_SET = 'at/panels/customer/CUSTOMER_PANEL_OPENED_FROM_URL_SET'
export const ALL_PROJECTS_ASSIGNED_SET = 'at/panels/customer/ALL_PROJECTS_ASSIGNED_SET'
export const CAN_MANAGE_SET = 'at/panels/customer/CAN_MANAGE_SET'
export const NEW_COMMENTS_ADD = 'at/panels/customer/NEW_COMMENTS_ADD'
export const OLD_COMMENTS_ADD = 'at/panels/customer/OLD_COMMENTS_ADD'
export const COMMENTS_INFO_CLEAR = 'at/panels/customer/COMMENTS_INFO_CLEAR'
export const COMMENT_REMOVE = 'at/panels/customer/COMMENT_REMOVE'
export const CHANGE_COMMENTS_ORDER = 'at/panels/customer/CHANGE_COMMENTS_ORDER'
export const COMMENTS_LOADED_SET = 'at/panels/customer/COMMENTS_LOADED_SET'
export const COMMENTS_LOADING_SET = 'at/panels/customer/COMMENTS_LOADING_SET'
export const SENDING_COMMENT_SET = 'at/panels/customer/SENDING_COMMENT_SET'
export const RECENTLY_ADDED_COMMENTS_ADD = 'at/panels/customer/RECENTLY_ADDED_COMMENTS_ADD'
export const RECENTLY_ADDED_COMMENTS_REMOVE = 'at/panels/customer/RECENTLY_ADDED_COMMENTS_REMOVE'
export const COMMENTS_SCROLL_TO_SET = 'at/panels/customer/COMMENTS_SCROLL_TO_SET'
export const EDITING_COMMENT_ID_SET = 'at/panels/customer/EDITING_COMMENT_ID_SET'
export const EDITING_COMMENT_TEXT_SET = 'at/panels/customer/EDITING_COMMENT_TEXT_SET'
export const UPDATE_COMMENT = 'at/panels/customer/UPDATE_COMMENT'
export const UPDATING_COMMENT_ID_SET = 'at/panels/customer/UPDATING_COMMENT_ID_SET'
export const SHOW_NEW_COMMENT_INPUT_SET = 'at/panels/customer/SHOW_NEW_COMMENT_INPUT_SET'
export const NEW_COMMENT_SET = 'at/panels/customer/NEW_COMMENT_SET'
export const NEW_COMMENT_REMOVE = 'at/panels/customer/NEW_COMMENT_REMOVE'



// WEBPACK FOOTER //
// ./web/js/panels/customer/actionTypes.js